import {Injectable} from '@angular/core';
import {HttpClientWrapperService} from '../config/http-client-wrapper.service';
import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class MobileInsuranceService {

  constructor(
    private http: HttpClientWrapperService,
    private authService: AuthService) {
  }

  getTypesList() {
    return this.http.get('mobile/statistics/device-type-list');
  }

  getBrandsList(typeID: number) {
    return this.http.get('mobile/statistics/device-brand-list?typeID=' + typeID);
  }

  getOffers(franchise: number, price: number, typeID: number, brandID: number, model: number, companyName: string) {
    return this.http.get(`mobile/statistics/offers?franchiseID=${franchise}
    &price=${price}&typeID=${typeID}&brandID=${brandID}&model=${model}&companyName=${companyName}`);
  }

  createRequest(info: any) {
    return this.http.post('mobile/insurance/create', info, this.authService.decode().auth);
  }

  getFranchiseList(companyName: number) {
    return this.http.get('mobile/statistics/franchise-list?companyName=' + companyName);
  }

  checkInfo(information: any) {
    return this.http.post('mobile/statistics/check-info', information);
  }

  getRequestInfo(requestID: number) {
    return this.http.get('mobile/statistics/request-details?requestID=' + requestID, this.authService.decode().auth);
  }

  uploadFile(requestID: number, fileType: string, file: File) {
    return this.http.upload('mobile/file-manager/upload?requestID=' + requestID + '&fileType=' + fileType,
      file, fileType, this.authService.decode().auth);
  }

  downloadNewInsurance(requestID: number) {
    return this.http.get('mobile/file-manager/released-insurance-file?mode=directLink&requestID='
      + requestID, this.authService.decode().auth);
  }

  getRequestID(mobile: string, requestToken: string) {
    return this.http.get('mobile/statistics/request-status?mobile=' + mobile + '&requestToken=' + requestToken);
  }
}
